import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileTypeAttachmentSolid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z",
			fill: "#424242"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.1016 23.2663L20.0912 29.2768C18.7244 30.6436 16.5083 30.6436 15.1415 29.2768C13.7746 27.9099 13.7746 25.6938 15.1415 24.327L21.1519 18.3166C22.0631 17.4054 23.5405 17.4054 24.4517 18.3166C25.3629 19.2278 25.3629 20.7052 24.4517 21.6164L18.677 27.3911C18.2214 27.8467 17.4827 27.8467 17.0271 27.3911C16.5715 26.9355 16.5715 26.1968 17.0271 25.7412L22.0947 20.6736",
			stroke: "white",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFileTypeAttachmentSolid;
